import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { PROPERTY_OWNERSHIP_V2_API } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

const getOwnershipAssociations = async (communityId: string, ownershipId: string) =>
  await axiosAuth.get(`${PROPERTY_OWNERSHIP_V2_API(communityId)}/${ownershipId}/associations`);

/** People on one ownership (expanded row on the Property Ownership screen). */
const useGetOwnershipAssociations = ({ communityId, ownershipId }: { communityId: string; ownershipId: string }): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["ownership-associations", communityId, ownershipId],
    queryFn: () => getOwnershipAssociations(communityId, ownershipId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId && !!ownershipId,
  });
};

export default useGetOwnershipAssociations;
